import { client } from './client'
import type { SandboxImage } from '@/types/sandboxImage'

export const sandboxImagesApi = {
  getAll: () =>
    client.get<SandboxImage[]>('/sandbox-images').then(r => r.data),
}
